export default "__VITE_ASSET__BfPK$feI__"